<template>
    <div
        class="topbar_heading_container vz_px"
        :class="[isDesktop.screenSize.value === 'xs' ? '!bg-white w-full pb-[1rem]' : 'bg-white']"
    >
        <slot></slot>
    </div>
</template>

<script setup>
import { useScreenSize } from "@/composables/globals";
const isDesktop = useScreenSize();
</script>

<style scoped>
.topbar_heading_container {
    @apply bg-gray-100 dark:bg-black-900 py-8 xs:py-6 xs:pb-4 sticky flex lg:items-center justify-between sm:left-16 dark:border-black-900 z-50 border-gray-200 w-full top-0 sm:items-start;
}
</style>
